<template>
  <b-container v-if="models" fluid>
    <page-title :icon="ecosystemModules.geofences.icon ? 'fas fa-' + (ecosystemModules.geofences.icon.type || ecosystemModules.geofences.icon) : 'fas fa-draw-polygon'">
      {{ecosystemModules.geofences.label || $gettext('GeoFences')}}
      <template #extras>
        <span v-if="activeTab === 0">
          <b-button variant="secondary" size="sm" :to="{name: 'GeofencesCreate'}">
            <font-awesome-icon icon="plus-circle" />
            {{ecosystemModules.geofences.label || $gettext('GeoFence')}}
          </b-button>
          <b-button variant="secondary" size="sm" v-translate v-b-modal.modalCsvImport>GeoFences' CSV Import</b-button>
        </span>
      </template>
    </page-title>
    <b-form-row class="m-0 p-0">
      <b-col class="m-0 p-0">
        <b-tabs content-class="mt-3 m-0 p-0" v-model="activeTab">
          <b-tab :title="$gettext('List')">
            <api-list type="geofences" :model="models.geofences" :quick-filters="quickFiltersSetup.geofences" ref="geofencesList" />
          </b-tab>
          <b-tab :title="$gettext('Map')">
            <general-map :visible="!!activeTab" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-form-row>
    <b-modal id="modalCsvImport" size="lg" ref="modalCsvImport" hide-footer>
      <template #modal-title>
        <translate>GeoFences' CSV Import</translate>
      </template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <csv-import @success="csvUploaded" @cancel="$refs.modalCsvImport.hide()" />
    </b-modal>

    <geofences-shared />
  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'
import GeneralMap from '@/components/Geofences/GeneralMapNew'
import CsvImport from '@/components/Geofences/CsvImport'
import GeofencesShared from '@/components/Geofences/Shared'

export default {
  name: 'GeofencesList',
  title() {
    return this.ecosystemModules.geofences.label || this.$gettext('GeoFences')
  },
  components: {
    ApiList,
    GeneralMap,
    CsvImport,
    GeofencesShared
  },
  data() {
    return {
      activeTab: 0,
      type: 'geofences',
      geoTypesSelect: []
    }
  },
  mounted () {
    this.geoTypesSelect = this.geoTypes.map(x => {
      return {
        text: this.toTitleCase(x.name),
        value: x.id,
        type: x.type
      }
    })
  },
  methods: {
    csvUploaded() {
      this.$refs.geofencesList.refreshTable()
      this.$refs.modalCsvImport.hide()
    }
  }
}
</script>
